export function toBoolean(value: unknown): boolean | undefined {
  if (typeof value === 'boolean') {
    return value
  } else if (typeof value === 'string') {
    try {
      return Boolean(JSON.parse(value))
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error: unknown) {
      return undefined
    }
  }

  return undefined
}
